import { defineElements } from "./element"

/**
 * `@usereq/widget` - the script a customer's page loads. Loading it defines
 * the two tags the install snippet writes, plus the previous platform's
 * `<usereq-agent-widget>`; importing it also gives a mount `render` for a
 * page that has the payload in hand.
 */

export { render } from "./mount"
export type { Mount, MountOptions } from "./mount"

defineElements()
